module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "plm_hd"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/SOTL_ser_pref"
    }
  }, [_vm._v("Series preface")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/SOTL_autpref"
    }
  }, [_vm._v("Author’s preface")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/SOTL_abbrev"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/SOTL_ch01"
    }
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("1 Introduction")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/SOTL_ch01#sigil_toc_id_2"
    }
  }, [_vm._v("Preliminary issues")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/SOTL_ch02"
    }
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("2 Adam: the first servant")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/SOTL_ch02#sigil_toc_id_4"
    }
  }, [_vm._v("God creates a servant")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/SOTL_ch02#sigil_toc_id_5"
    }
  }, [_vm._v("The servant fails")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/SOTL_ch02#sigil_toc_id_6"
    }
  }, [_vm._v("God calls a servant")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/SOTL_ch02#sigil_toc_id_7"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("3 Moses: the servant prophet")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch03#sigil_toc_id_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Setting the stage")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch03#sigil_toc_id_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Moses as servant of Yahweh in the Torah")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch03#sigil_toc_id_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Moses as servant of Yahweh in the Prophets and the Writings")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch03#sigil_toc_id_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("4 Joshua: the servant conqueror")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch04#sigil_toc_id_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The transition from one servant to another")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch04#sigil_toc_id_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joshua does what Moses the servant commanded")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch04#sigil_toc_id_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yahweh performs similar acts through Joshua")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch04#sigil_toc_id_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The death of Joshua the servant")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch04#sigil_toc_id_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("5 David: the servant king")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch05#sigil_toc_id_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Israel’s need for a servant")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch05#sigil_toc_id_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The life of David the servant")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch05#sigil_toc_id_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Solomon the servant’s son")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch05#sigil_toc_id_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The eschatological hope in David the servant")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch05#sigil_toc_id_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("6 The Isaianic servant: the suffering servant")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch06#sigil_toc_id_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Servant references in Isaiah 1 – 39")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch06#sigil_toc_id_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The servant in Isaiah 40 – 665")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch06#sigil_toc_id_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("7 Jesus: the servant par excellence")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch07#sigil_toc_id_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Servant language applied to Jesus")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch07#sigil_toc_id_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesus as the fulfilment of previous servants")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch07#sigil_toc_id_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("8 The apostles: servants of Christ")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch08#sigil_toc_id_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul the servant of Christ")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch08#sigil_toc_id_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s ministry co-workers")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch08#sigil_toc_id_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peter the servant of Christ")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch08#sigil_toc_id_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("James the servant of God and of the Lord Jesus Christ")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch08#sigil_toc_id_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jude the servant of Christ")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch08#sigil_toc_id_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John the servant of Christ")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch08#sigil_toc_id_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("9 The church: a servant people")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch09#sigil_toc_id_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gospels and Acts")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch09#sigil_toc_id_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s letters")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch09#sigil_toc_id_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Catholic epistles")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch09#sigil_toc_id_45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Revelation")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch09#sigil_toc_id_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("10 Conclusion")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ch10#sigil_toc_id_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Implications")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_biblio",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ind_aut",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Search names for authors")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ind_scrip",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Search items for Scripture references")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_ind_anc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Search items for ancient sources")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_series",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Titles in this series")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/SOTL_notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/UK_ata",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the author")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/UK_moreIVP",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3573ba56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/SOTL_contents.vue
// module id = 66
// module chunks = 0